import React, { Component } from 'react'
import { getData2 } from '../Api/Config'


class Badges extends Component{
    
    state={
        completedApp: 0,
        iceBoxApp: 0,
        inProgressApp: 0,
        inReviewApp: 0,
        liveApp: 0,
        todoApp: 0
      }
    styleIcon=(color)=>{
        return {
          borderRadius:'100px',
          fontSize:'32px',
          padding:'10px',
          background:color,
          color: '#ffffff'
        }
      }

    titleStyle={
    fontWeight: 400,
    color: 'darkslategrey'
   }   

   componentDidMount=()=>{
    getData2("https://api.nirmallabs.com/api/admin/v1/summary").then(res=>{
      if(res){
        this.setState({
          completedApp: res.completedApp,
          iceBoxApp: res.iceBoxApp,
          inProgressApp: res.inProgressApp,
          inReviewApp: res.inReviewApp,
          liveApp: res.liveApp,
          todoApp: res.todoApp
        });
      }
    }).catch(err=>{
      console.log(err);
    })
  }
   render(){   
    return (
        <div>
                <h6>App Status</h6>
                <div className="row">
                <div className="col s12 m6 xl4">
                  <div className="card">
                    <div className="card-content">
                      <span className="card-title" style={this.titleStyle}>Ice Box <i className="material-icons right" style={this.styleIcon('#03a9f4')}>ac_unit</i></span>
                      <p style={{fontWeight:'bold'}}>{this.state.iceBoxApp}</p>
                      
                    </div>
                  </div>
                </div>
                <div className="col s12 m6 xl4">
                  <div className="card">
                  <div className="card-content">
                      <span className="card-title" style={this.titleStyle}>TO Do <i className="material-icons right" style={this.styleIcon('#00e676')}>today</i></span>
                      <p style={{fontWeight:'bold'}}>{this.state.todoApp}</p>
                    </div>
                  </div>
                </div>
                <div className="col s12 m6 xl4">
                  <div className="card">
                  <div className="card-content">
                      <span className="card-title" style={this.titleStyle}>In Progress <i className="material-icons right" style={this.styleIcon('#ffb300')}>update</i></span>
                      <p style={{fontWeight:'bold'}}>{this.state.inProgressApp}</p>
                    </div>
                  </div>
                </div>
                </div>
                <div className="row" style={{marginTop:'-100px'}}>
                <div className="col s12 m6 xl4">
                  <div className="card">
                    <div className="card-content">
                      <span className="card-title" style={this.titleStyle}>In Review <i className="material-icons right" style={this.styleIcon('#ff3d00')}>rate_review</i></span>
                      <p style={{fontWeight:'bold'}}>{this.state.inReviewApp}</p>
                    </div>
                  </div>
                </div>
                <div className="col s12 m6 xl4">
                  <div className="card">
                  <div className="card-content">
                      <span className="card-title" style={this.titleStyle}>Completed <i className="material-icons right" style={this.styleIcon('#64dd17')}>done</i></span>
                      <p style={{fontWeight:'bold'}}>{this.state.completedApp}</p>
                    </div>
                  </div>
                </div>
                <div className="col s12 m6 xl4">
                  <div className="card">
                  <div className="card-content">
                      <span className="card-title" style={this.titleStyle}>Live <i className="material-icons right" style={this.styleIcon('#ff1744')}>publish</i></span>
                      <p style={{fontWeight:'bold'}}>{this.state.liveApp}</p>
                    </div>
                  </div>
                </div>
                </div>
        </div>
    )
   }
}

export default Badges
